import { DivergenceStatusEnum } from "@/enum/divergence-status";

const DECIDED_STATUSES: readonly DivergenceStatusEnum[] = [
  DivergenceStatusEnum.APPROVED,
  DivergenceStatusEnum.REJECTED,
];

export interface DecidableRow {
  id: number;
  status?: DivergenceStatusEnum | null;
}

const isDecided = (row: DecidableRow): boolean =>
  DECIDED_STATUSES.includes(row.status as DivergenceStatusEnum);

export const decidedElsewhereIds = (
  previous: readonly DecidableRow[],
  current: readonly DecidableRow[]
): number[] => {
  const undecidedBefore: Set<number> = new Set(
    previous
      .filter((row: DecidableRow): boolean => !isDecided(row))
      .map((row: DecidableRow): number => row.id)
  );

  return current
    .filter(
      (row: DecidableRow): boolean =>
        undecidedBefore.has(row.id) && isDecided(row)
    )
    .map((row: DecidableRow): number => row.id);
};

export const decidedElsewhereCount = (
  previous: readonly DecidableRow[],
  current: readonly DecidableRow[]
): number => decidedElsewhereIds(previous, current).length;
